import { TSetSelectedDateParams } from '@/components/CustomCalendar/type';
import CalendarList from '@/components/desktop/CalendarList';
import IOSSwitch from '@/components/IosSwitch';
import {
  setChooseReturn,
  setDepartDate,
  setReturnDate,
  setSelectedDate,
  setShowCalendarVietNam,
} from '@/slices/calendar/calendarSlice';
import {
  TMinFareObj,
  useLazyGetFlightStatistics2Query,
} from '@/slices/flightData/apis/flightDataApi';
import { style } from '@/styles/globals';
import { getAreaPointArr } from '@/utils';
import { clearAnchorPopperInput } from '@/utils/eventEmitter';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import {
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
  Box,
} from '@mui/material';
import { styled } from '@mui/system';
import { monthYears } from '@/utils/monthYears';
import { TGenerateFlightCountRequest } from '@/utils/generateFlightRequest';
import { FC, useEffect } from 'react';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';
// import { IS_SHOW_CALENDAR_VN } from '@/utils/constants';

export const VectorIconWrapper = styled('div')({
  display: 'inline',
  background: style.color.white,
  borderRadius: '50%',
  position: 'absolute',
  top: '2em',
  right: '2em',
  boxShadow: style.boxShadow.customShadow,
});

interface SelectDateProps {
  type: 'depart' | 'return';
  onSearchFlight: any;
  lang?: ILangObj;
  countResult?: any;
}

const CalendarFareInMonthVcmsDesktop: FC<SelectDateProps> = ({
  type, onSearchFlight, lang, countResult,
}) => {
  const { startPointHome, toPointHome } = useAppSelector(
    (state) => state.searchFlightForm,
  );
  // const startPoint = startPointHome;
  // const toPoint = toPointHome;
  const stateSelectedDate = useAppSelector(
    (state) => state.calendar.selectedDate,
  );

  const selectedDepartDate = new Date(stateSelectedDate.depart);
  const selectedReturnDate = stateSelectedDate.return
    ? new Date(stateSelectedDate.return)
    : null;
  const selectedDate = {
    depart: selectedDepartDate,
    return: selectedReturnDate,
  };

  const setSelectedDateFunc = (params: TSetSelectedDateParams) => {
    if (
      type === 'depart'
      && params
      && params.depart !== undefined
      && params.depart !== selectedDepartDate
    ) {
      if (params?.return) {
        dispatch(
          setSelectedDate({
            dateObj: JSON.stringify(params),
          }),
        );
      } else {
        dispatch(
          setDepartDate({
            depart: params.depart.toISOString(),
          }),
        );
      }
    }
    if (
      type === 'return'
      && params
      && params.return !== null
      && params.return !== selectedReturnDate
    ) {
      dispatch(
        setReturnDate({
          return: params?.return.toISOString(),
        }),
      );
    }
    onSearchFlight(params);
    setTimeout(() => {
      clearAnchorPopperInput();
    }, 100);
  };

  const [getMinFare, { isLoading, data: staticData }] = useLazyGetFlightStatistics2Query();
  const flightRequest: TGenerateFlightCountRequest = {
    from: startPointHome ? getAreaPointArr(startPointHome) : [],
    to: toPointHome ? getAreaPointArr(toPointHome) : [],
    month_years: monthYears(),
    flight_class: 'PT',
    // disable_update_filter: 1,
  };

  const dayPriceObj = {} as TMinFareObj;
  const data = staticData || countResult;
  data?.forEach((group: { grouped_by_date: { [x: string]: { min_fare: number; }; }; }) => {
    Object.keys(group?.grouped_by_date).forEach((groupedDate) => {
      dayPriceObj[groupedDate] = group?.grouped_by_date[groupedDate].min_fare;
    });
  });
  const isShowCalendarVietNam = useAppSelector(
    (state) => state.calendar.showCalendarVietNam,
  );
  // React.useEffect(() => {
  //   // @ts-ignore
  //   const showCalendarVietNam = !!+window.localStorage.getItem(
  //     IS_SHOW_CALENDAR_VN,
  //   );
  //   dispatch(setShowCalendarVietNam({ value: showCalendarVietNam }));
  // }, []);

  const dispatch = useAppDispatch();

  const handleOnClick = () => {
    const isReturn = type === 'return' && !selectedDate.return;
    if (startPointHome && toPointHome) {
      getMinFare(flightRequest);
    }
    if (isReturn) {
      dispatch(setChooseReturn({ chooseReturn: true }));
    }
    window.scrollTo({
      top: 115,
      left: 0,
      behavior: 'smooth',
    });
  };
  // useEffect(() => {
  //   if (startPointHome && toPointHome) {
  //     getMinFare(flightRequest);
  //   }
  // }, [startPointHome, toPointHome]);
  useEffect(() => {
    handleOnClick();
  }, []);

  return (
    <ContentContainer
      style={{
        padding: `${pr`16px`} 0`,
        overflow: 'hidden',
      }}
    >
      <Stack
        sx={{
          zIndex: 10,
        }}
      >
        <FormGroup
          style={{
            display: 'flex',
            textAlign: 'end',
            marginBottom: pr`10`,
          }}
        >
          <FormControlLabel
            style={{
              justifyContent: 'flex-end',
              marginLeft: '10px',
            }}
            componentsProps={{
              typography: {
                ...style.text.content.regular,
                color: style.color.black2,
              },
            }}
            control={(
              <IOSSwitch
                size="small"
                color="secondary"
                defaultChecked={isShowCalendarVietNam}
                checked={isShowCalendarVietNam}
              />
              )}
            label={(
              <Typography
                variant="body2"
                sx={{ marginLeft: '8px' }}
              >
                {lang?.global?.lunarYear || 'Lịch âm'}
              </Typography>
              )}
            defaultChecked={isShowCalendarVietNam}
            onChange={(value: any) => dispatch(
              setShowCalendarVietNam({ value: value?.target?.checked }),
            )}
          />
        </FormGroup>
      </Stack>
      {(isLoading && !data) ? (
        <div
          style={{
            width: '100%',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress color="inherit" />
        </div>
      ) : (
        <CalendarList
          type={type}
          dayPriceObj={dayPriceObj}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDateFunc}
          isVcms
          lang={lang}
        />
      )}
    </ContentContainer>
  );
};

export const ContentContainer = styled(Box)`
  padding: 16px;
  border: 1px solid #e8edf1;
  box-sizing: border-box;
  box-shadow: 0px 2px 10px rgb(7 65 57 / 15%);
  border-radius: 6px;
  background: white;
  max-height: 472px;
  width: 70%;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 0 auto;
`;

export default CalendarFareInMonthVcmsDesktop;
